import React from "react";
import DataTable from "react-data-table-component";
import SubHeaderComponent from "./SubHeaderComponent";
import TableSkeleton from "./TableSkeleton";
import CustomPagination from "./CustomPagination";
import Checkbox from "components/Checkbox";
import { useFormattedMessage } from "hooks";

// prepare five tile of skeleton to show on loading users collection
const skeletonModal = (totalItems) => {
    const elements = [];
    for (let index = 0; index < totalItems; index++) {
        elements[index] = <TableSkeleton key={`skeleton-${index}`} />;
    }
    return <div className="w-100">{elements}</div>;
};

const CustomCheckBox = (props) => {
    return <Checkbox inputClassName="cursor-pointer" size="small" {...props} indeterminate={props?.indeterminate} />;
};
const selectProps = { indeterminate: (isIndeterminate) => isIndeterminate };

const CustomDataTable = ({
    data,
    filteredData,
    columns,
    title,
    handleRowSelected = () => {},
    selectableRows = false,
    selectableRowsHighlight = false,
    pagination = true,
    paginationServer,
    totalRows,
    onChangeRowsPerPage,
    handlePageChange,
    className,
    theme = "light",
    pointerOnHover = true,
    selectableRowsVisibleOnly = false,
    selectableRowsRadio = "checkbox", // checkbox or radio
    searchBoxFields,
    selectFilterFields,
    onSearchAndFilter,
    paginationPerPage = 20,
    isShowFilters = true,
    selectedProducts,
    filterProductColumn,
    isShowSelectedProductData = false,
    progressPending,
    noDataComponent,
    ...rest
}) => {
    const { formatMessage } = useFormattedMessage();
    const customStyle = {
        subHeader: {
            style: {
                minHeight: 45,
                display: "block",
                paddingLeft: 10,
                paddingRight: 10,
                paddingTop: 4,
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
                marginBottom: 4,
            },
        },
    };
    return (
        <div className={`custom-data-table ${isShowFilters ? "" : "hide-table-header"}`}>
            <DataTable
                theme={theme}
                className={`table ${className} ${
                    isShowSelectedProductData && Array.isArray(selectedProducts) && selectedProducts?.length > 0
                        ? "top-radius-0"
                        : ""
                }`}
                title={title}
                customStyles={customStyle}
                columns={columns}
                data={filteredData}
                selectableRows={selectableRows} // Enable row selection
                onSelectedRowsChange={handleRowSelected}
                selectableRowsHighlight={selectableRowsHighlight} // Highlight selected rows
                pagination={pagination} // Enable pagination if needed
                subHeader
                progressComponent={skeletonModal(paginationPerPage)}
                paginationComponent={CustomPagination}
                subHeaderComponent={
                    <SubHeaderComponent
                        isServer={paginationServer}
                        onSearchAndFilter={onSearchAndFilter}
                        data={data}
                        filteredItems={filteredData}
                        searchFilter={searchBoxFields}
                        selectFilters={selectFilterFields}
                        theme={theme}
                        tableClassName={className}
                        customStyle={customStyle}
                        filterProductColumn={filterProductColumn}
                        selectedProducts={selectedProducts}
                        isShowSelectedProductData={isShowSelectedProductData}
                        isShowCheckboxInTable={selectableRows}
                        progressPending={progressPending}
                    />
                }
                selectableRowsComponent={CustomCheckBox}
                selectableRowsComponentProps={selectProps}
                paginationPerPage={paginationPerPage}
                paginationServer={paginationServer}
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={onChangeRowsPerPage}
                onChangePage={handlePageChange}
                pointerOnHover={pointerOnHover}
                selectableRowsVisibleOnly={selectableRowsVisibleOnly}
                selectableRowsRadio={selectableRowsRadio}
                selectableRowsSingle={selectableRowsRadio === "radio"}
                progressPending={progressPending}
                noDataComponent={noDataComponent || <span className="p-6">{formatMessage("table_no_data_found")}</span>}
                {...rest}
            />
        </div>
    );
};

export default CustomDataTable;
